import { Injectable } from '@angular/core';
import { AuthorityConfiguration } from './authority-configuration';
import { RegionStorageService } from 'src/app/shared/region/region-storage.service';
import { ConfigurationModule } from '../../configuration.module';
import { AuthorityStorageService } from '../authority-storage.service';

@Injectable({
  providedIn: ConfigurationModule
})
export class AuthorityConfigurationService {
  configurations: AuthorityConfiguration[] = [];

  constructor(private regionStorageService: RegionStorageService,
    private authorityStorageService: AuthorityStorageService
  ) { }

  loadConfigurations(configurations) {
    for (const configuration of configurations) {
      this.configurations.push(configuration);
    }
  }

  getDefaultConfiguration() {
    let configuration = this.configurations[0];
    configuration.protocol = "https";
    configuration.domain = this.authorityStorageService.loadAuthority().replace(/^https?:\/\//, "");
    configuration.addSuperBatmanHeader = false;
    configuration.default = true;

    return configuration;
  }
 
  getLocalConfiguration() {
    let configuration = this.configurations[0];
    configuration.protocol = "https";
    configuration.domain = this.authorityStorageService.loadAuthority().replace(/^https?:\/\//, "");
    configuration.addSuperBatmanHeader = false;
    configuration.default = true;

    return configuration;
  }

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }
}
